(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/details/competition-details.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/details/competition-details.js');
"use strict";

const {
  HighscoreListType
} = svs.components.marketplaceCompetition.services.constants.highscoreConstants;
const {
  CompetitionDetailsIndividual,
  CompetitionDetailsTeams
} = svs.components.marketplaceCompetition.routeResult.details;
const CompetitionDetails = _ref => {
  let {
    drawResults = [],
    type,
    numberOfDraws
  } = _ref;
  const isTeamDetails = type === HighscoreListType.Team;
  return React.createElement(React.Fragment, null, isTeamDetails && React.createElement(CompetitionDetailsTeams, {
    drawResults: drawResults,
    isTeamDetails: isTeamDetails
  }), !isTeamDetails && React.createElement(CompetitionDetailsIndividual, {
    drawResults: drawResults,
    numberOfDraws: numberOfDraws
  }));
};
setGlobal('svs.components.marketplaceCompetition.routeResult.details.CompetitionDetails', CompetitionDetails);

 })(window);